export enum AdminType {
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN'
}

export interface AdminAuthRequest {
  login: string;
  password: string;
}

export interface AdminResponse {
  id: number;
  name: string;
  phone: string;
  email: string;
  adminType: AdminType;
}

export interface AdminAuthResponse {
  admin: AdminResponse;
  token: string;
}

export interface RefreshTokenRequest {
  callerId: number;
  token: string;
}

export interface JWTResponse {
  token: string;
}

export interface ApiResponse<T> {
  data?: T;
  error?: string;
  success: boolean;
}

export interface CreateAdminRequest {
  name: string;
  phone: string;
  email: string;
  adminType: AdminType;
  login: string;
  password: string;
}